import React, { Component } from 'react';
import styled from 'styled-components';
import arrowLeft from '../../assets/images/arrow_left.png';
import arrowRight from '../../assets/images/arrow_right.png';

const Container = styled.div`
  /* border: 5px solid red; */
  /* flex-direction: column; */
  overflow: hidden;

  @media (max-width: 576px) {
    /* background-color: rgba(201, 76, 76, 0.9); */
    justify-content: center;
  }
  @media (max-width: 768px) {
    /* background-color: rgba(201, 76, 76, 0.9); */
  }
`;

const Slider = styled.div`
  /* border: 5px solid blue; */
  /* height: 100%;
  width: 100%;
  display: flex; */

  @media (max-width: 576px) {
    /* background-color: rgba(201, 76, 76, 0.9); */
    flex-direction: column;
    width: 100%;
    padding: 20px;
    justify-content: center;
  }

  @media (max-width: 768px) {
    padding: 20px 0;
    /* background-color: rgba(201, 76, 76, 0.9); */
  }
`;

const Caption = styled.p`
  writing-mode: vertical-lr;
  text-align: left;
  font-weight: bolder;
  margin: 0;
  height: max-content;
  width: max-content;
  transform: rotate(180deg);
  font-family: AvenirBold;
  margin-top: 10px;

  @media (max-width: 576px) {
    writing-mode: horizontal-tb;
    text-align: left;
    font-weight: bolder;
    margin: 0;
    height: max-content;
    width: max-content;
    transform: rotate(0deg);
    margin: 5px 0;
  }
`;
const Image = styled.img`
  /* border: 5px solid red; */
  max-width: 95%;
  /* height:;? */
  overflow: hidden;
  flex-grow: 1;
  object-fit: cover;
  object-position: center;
  @media (max-width: 576px) {
    max-width: 100%;
  }

  @media (max-width: 768px) {
    /* border: 5px solid red; */
  }
`;

const ArrowImage = styled.img`
  margin: 0 6px;
  filter: invert(1);
  width: 32px;
  height: 32px;
`;

const BottomNavBar = styled.div`
  /* border: 5px solid black; */
  height: fit-content;
  width: fit-content;
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: 576px) {
    display: none;
  }
`;
const Count = styled.span`
  color: black;
  /* border: 5px solid yellow; */
  padding-right: 7px;
`;

const Arrow = styled.span`
  color: black;
  padding: 10px 0;
  /* border: 5px solid green; */
  display: flex;
  justify-content: space-around;
`;

const ArrowContainer = styled.div`
  /* background-color:  red; */
  &:active {
    /* animation: shake 0.5s cubic-bezier(0.96, 0.9, 0.19, 0.97) both; */
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    /* perspective: 1000px; */
    color: red;
  }

  /* @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, -1px, 10px);
    }

    20%,
    80% {
      transform: translate3d(2px, 2px, 20px);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, -4px, 40px);
    }

    40%,
    60% {
      transform: translate3d(4px, 4px, 40px);
    }
  } */
`;

const SliderItem = styled.div`
  /* border:5px solid  green; */
  height: 450px;

  transform: translateX(${props => props.animated}%);
  transition: transform 900ms ease-in;

  @media (max-width: 768px) {
    min-width: 60%;
    min-height: 50%;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    margin-bottom: 50px;
  }
`;

class Carousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      index: 1,
      animated: 0
    };
  }

  componentDidMount() {
    const count = this.props.data.length;
    this.setState({ count });
  }

  handlePrevious() {
    var { count, index, animated } = this.state;

    if (index > 1) {
      this.setState({
        index: index - 1,
        animated: animated + 100
      });
    } else {
      this.setState({
        index: count - 1,
        animated: (count - 2) * -100
      });
    }
  }

  handleNext() {
    var { count, index, animated } = this.state;

    if (index < count - 1) {
      this.setState({
        index: index + 1,
        animated: animated - 100
      });
    } else {
      this.setState({
        index: 1,
        animated: 0
      });
    }
  }

  render() {
    var { count, index } = this.state;
    const items = this.props.data;

    return (
      <div>
        <Container>
          <BottomNavBar>
            <Count>
              <strong>0{index}</strong> / 0{count}
            </Count>
            <Arrow>
              <ArrowContainer onClick={this.handlePrevious.bind(this)}>
                <ArrowImage src={arrowLeft} />
              </ArrowContainer>
              <ArrowContainer onClick={this.handleNext.bind(this)}>
                <ArrowImage src={arrowRight} />
              </ArrowContainer>
            </Arrow>
          </BottomNavBar>

          <Slider id='slider' className='row flex-nowrap w-100'>
            {items.map(item => (
              <SliderItem
                className='col-12 col-md-6 d-flex align-self-start'
                style={{ paddingRight: 0 }}
                animated={this.state.animated}>
                <Image
                  style={{
                    height: `${item.id % 2 == 0 ? '70%' : '100%'}`,
                    paddingRight: '15px'
                  }}
                  src={item.url}
                  alt='Img'
                />
                <Caption>{item.text}</Caption>
              </SliderItem>
            ))}
          </Slider>
        </Container>
      </div>
    );
  }
}

export { Carousel };
